import { inject, Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '../../components/data-input/form-inputs/form-input-select.component';
import { INormalText, ITextLanguageValue } from '@web/dtos';
import { LanguageService } from '../../services/language/language.service';

@Pipe({
  name: 'toTranslatedOption',
  standalone: true,
})
export class ToTranslatedOptionPipe implements PipeTransform {
  languageService: LanguageService = inject(LanguageService);

  transform(texts: INormalText[]): SelectOption[] {
    return texts.map((text: INormalText): string => {
      return (
        text.text.values.filter(
          (value: ITextLanguageValue) =>
            value.languagePrefix ===
            this.languageService.activeLanguage().prefix
        )[0]?.value ?? '-'
      );
    });
  }
}
